import Icon from './Icon';

// Two-line mobile list row — the shared anatomy for every mobile table
// replacement (lookup screens render these instead of tables at ≤640px).
//
// RTL layout: the primary text block anchors the right edge (where Hebrew
// eyes land first), the numeric column anchors the left edge so amounts
// align down the list like a virtual table column.
//
//   variant 'nav'       — whole row navigates somewhere (‹ chevron)
//   variant 'accordion' — row expands in place (⌄ caret, rotates when open;
//                         caller renders the expanded content below the row)
//   variant 'plain'     — no chevron (static/informational rows)
//
// `amount` renders in the RTL flow (he-IL currency strings already place ₪
// on the left there); `endSub` is the second end-column line (e.g. a %
// delta chip).
export default function ListRow({
  primary,
  meta,
  badge,
  amount,
  endSub,
  variant = 'nav',
  expanded = false,
  onClick,
  className = '',
}) {
  return (
    <button
      type="button"
      className={`m-row${className ? ` ${className}` : ''}`}
      onClick={onClick}
      aria-expanded={variant === 'accordion' ? expanded : undefined}
    >
      <div className="m-row-main">
        <div className="m-row-primary">{primary}</div>
        {(meta || badge) && (
          <div className="m-row-meta">
            {meta}
            {badge}
          </div>
        )}
      </div>
      {(amount != null || endSub) && (
        <div className="m-row-end">
          {/* Rendered in the ambient RTL direction — formatCurrency's he-IL
              output places ₪ visually to the LEFT of the number there,
              matching the desktop tables. Forcing dir="ltr" flips it. */}
          {amount != null && <span className="m-row-amount">{amount}</span>}
          {endSub}
        </div>
      )}
      {variant === 'accordion' && (
        <Icon name="chevron" size={16} className={`m-row-chevron m-row-caret${expanded ? ' is-open' : ''}`} />
      )}
      {variant === 'nav' && (
        /* An icon, not a text chevron: '‹' is bidi-mirrored, so RTL rendering
           flips it into '›' (pointing backward). `chevron-inline` always points
           left — the forward direction in an RTL app. */
        <Icon name="chevron-inline" size={16} className="m-row-chevron" />
      )}
    </button>
  );
}
